import {TranslateService} from '@ngx-translate/core';

import {Scss} from '../../shared/utils/scss';

export const getWorkflowByTypeChartConfig = (
  countByType: {[key: string]: number},
  workflowTypes: {key: string}[],
  resolvedStatusColors: {[key: string]: string},
  translate: TranslateService
) => {

  // Assign the color per data item by type key (same logic as the "old workflows"
  // chart) so a given workflow type always renders with the exact same color in
  // both charts, even when some type has no dedicated color.
  const pieChartData = workflowTypes.map(type => {
    return {
      name: translate.instant(type.key),
      value: countByType[type.key],
      itemStyle: {
        color: resolvedStatusColors[type.key] || Scss.variable('chart-fallback')
      }
    };
  });


  return {
    title: {
      text: translate.instant('PROCESS_MONITOR.process_by_type_chart_title'),
      top: '1%',
      left: 'center'
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b}: {c} ({d}%)',
      confine: true
    },
    legend: {
      orient: 'vertical',
      left: 'left',
      top: '15%',
      itemGap: 3,
      textStyle: {
        fontSize: 12
      },
      data: pieChartData.map(item => item.name)
    },
    series: [
      {
        name: translate.instant('PROCESS_MONITOR.process_by_type_chart_title'),
        type: 'pie',
        radius: '60%',
        center: ['77%', '50%'],
        data: pieChartData,
        itemStyle: {
          normal: {label: {show: false}}
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  };
};
